import { render, staticRenderFns } from "./ResourceViewBasketAdmin.vue?vue&type=template&id=b376a768&"
import script from "./ResourceViewBasketAdmin.vue?vue&type=script&lang=js&"
export * from "./ResourceViewBasketAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports